var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { useFormik } from 'formik';
import { FormikCheckboxGroup } from './atoms/CheckboxGroup';
import { FormikTextField } from './atoms/TextField';
import Button from './atoms/BaseButton';
import { TradeCountryUsages, TradeCountryProcessings, TradeCountryPriceRanges, } from '../constants/roasterValues';
var toFormValues = function (tradeCountry) { return ({
    usages: tradeCountry.usages,
    processings: tradeCountry.processings,
    priceRanges: tradeCountry.priceRanges,
    note: tradeCountry.note,
}); };
var TradeCountryEditForm = function (_a) {
    var tradeCountry = _a.tradeCountry, onConfirm = _a.onConfirm;
    var initialValues = React.useMemo(function () { return toFormValues(tradeCountry); }, [tradeCountry]);
    var t = useTranslation().t;
    var onSubmit = React.useCallback(function (values) {
        onConfirm(__assign(__assign({}, tradeCountry), { usages: values.usages, processings: values.processings, priceRanges: values.priceRanges, note: values.note }));
    }, [onConfirm, tradeCountry]);
    var formik = useFormik({
        initialValues: initialValues,
        onSubmit: onSubmit,
        enableReinitialize: true,
    });
    var usagesItems = React.useCallback(function () {
        return TradeCountryUsages.map(function (value) { return ({
            label: t("tradeCountryUsages.".concat(value)),
            value: value,
        }); });
    }, [t]);
    var processingsItems = React.useCallback(function () {
        return TradeCountryProcessings.map(function (value) { return ({
            label: t("tradeCountryProcessings.".concat(value)),
            value: value,
        }); });
    }, [t]);
    var priceRangesItems = React.useCallback(function () {
        return TradeCountryPriceRanges.map(function (value) { return ({
            label: t("tradeCountryPriceRanges.".concat(value)),
            value: value,
        }); });
    }, [t]);
    return (React.createElement("form", { onSubmit: formik.handleSubmit },
        React.createElement(Grid, { container: true, style: { marginTop: 5 } },
            React.createElement(Grid, { item: true, container: true, xs: 12, spacing: 1 },
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikCheckboxGroup, { label: t('labels.tradeCountryUsages'), name: "usages", items: usagesItems(), formik: formik })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikCheckboxGroup, { label: t('labels.tradeCountryProcessings'), name: "processings", items: processingsItems(), formik: formik })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikCheckboxGroup, { label: t('labels.tradeCountryPriceRanges'), name: "priceRanges", items: priceRangesItems(), formik: formik })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikTextField, { label: t('labels.memo'), name: "note", fullWidth: true, multiline: true, rows: 3, formik: formik })),
                React.createElement(Grid, { item: true, xs: 12, style: { marginTop: 5 }, textAlign: "center" },
                    React.createElement(Button, { onClick: function () { return onSubmit(formik.values); }, color: "primary" }, t('buttons.complete')))))));
};
export default TradeCountryEditForm;
